// Plain module (not a component) so this can sit alongside PracticeDoctorLabel.tsx
// without tripping react-refresh/only-export-components - same split as
// accountTypeTone.ts next to IdentityChip.tsx.

export type PracticeDoctorLabelFormat = 'doctor-practice' | 'practice-doctor' | 'practice-only';

/**
 * Renders the text for a (practice, doctor) pair without any risk coloring -
 * exported so callers that need to know up front whether there's anything to
 * show (e.g. to conditionally render a "·" separator around the label) don't
 * have to re-derive this themselves. `<PracticeDoctorLabel>` uses this
 * internally.
 *
 *   - 'doctor-practice' -> "Dr Jane Doe (Practice)" - work-queue's
 *     practiceDoctorLabel / Patients.tsx's practiceLine.
 *   - 'practice-doctor' -> "Practice · Dr Jane Doe" - SearchDropdown's
 *     result rows.
 *   - 'practice-only'   -> "Practice" - everywhere only the practice name is
 *     shown (doctor rendered separately, or not at all).
 */
export function formatPracticeDoctorLabel(
    format: PracticeDoctorLabelFormat,
    practiceName?: string | null,
    doctorName?: string | null
): string {
    const dr = doctorName?.trim() ?? '';
    const name = practiceName?.trim() ?? '';
    if (format === 'practice-only') return name;
    if (format === 'doctor-practice') return dr && name ? `${dr} (${name})` : dr || name;
    return dr && name ? `${name} · ${dr}` : name || dr;
}
